import fronts from '@/apis/coreIAM/fronts'
import { frontsTypes } from '@/store/mutationTypes'

export default {
    state: {
        getDefaultScopes: {
            pending: false,
            error: null,
        },
        addDefaultScope: {
            pending: false,
            error: null,
        },
        removeDefaultScope: {
            pending: false,
            error: null,
        },
        getOptionalScopes: {
            pending: false,
            error: null,
        },
        addOptionalScope: {
            pending: false,
            error: null,
        },
        removeOptionalScope: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [frontsTypes.FETCH_ALL_DEFAULT_SCOPES_REQUEST]: function (state) {
            state.getDefaultScopes.pending = true;
        },
        [frontsTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS]: function (state) {
            state.getDefaultScopes.error = null;
            state.getDefaultScopes.pending = false;
        },
        [frontsTypes.FETCH_ALL_DEFAULT_SCOPES_FAILURE]: function (state, error) {
            state.getDefaultScopes.error = error;
            state.getDefaultScopes.pending = false;
        },
        [frontsTypes.ADD_DEFAULT_SCOPE_REQUEST]: function (state) {
            state.addDefaultScope.pending = true;
        },
        [frontsTypes.ADD_DEFAULT_SCOPE_SUCCESS]: function (state) {
            state.addDefaultScope.error = null;
            state.addDefaultScope.pending = false;
        },
        [frontsTypes.ADD_DEFAULT_SCOPE_FAILURE]: function (state, error) {
            state.addDefaultScope.error = error;
            state.addDefaultScope.pending = false;
        },
        [frontsTypes.REMOVE_DEFAULT_SCOPE_REQUEST]: function (state) {
            state.removeDefaultScope.pending = true;
        },
        [frontsTypes.REMOVE_DEFAULT_SCOPE_SUCCESS]: function (state) {
            state.removeDefaultScope.error = null;
            state.removeDefaultScope.pending = false;
        },
        [frontsTypes.REMOVE_DEFAULT_SCOPE_FAILURE]: function (state, error) {
            state.removeDefaultScope.error = error;
            state.removeDefaultScope.pending = false;
        },
        [frontsTypes.FETCH_ALL_OPTIONAL_SCOPES_REQUEST]: function (state) {
            state.getOptionalScopes.pending = true;
        },
        [frontsTypes.FETCH_ALL_OPTIONAL_SCOPES_SUCCESS]: function (state) {
            state.getOptionalScopes.error = null;
            state.getOptionalScopes.pending = false;
        },
        [frontsTypes.FETCH_ALL_OPTIONAL_SCOPES_FAILURE]: function (state, error) {
            state.getOptionalScopes.error = error;
            state.getOptionalScopes.pending = false;
        },
        [frontsTypes.ADD_OPTIONAL_SCOPE_REQUEST]: function (state) {
            state.addOptionalScope.pending = true;
        },
        [frontsTypes.ADD_OPTIONAL_SCOPE_SUCCESS]: function (state) {
            state.addOptionalScope.error = null;
            state.addOptionalScope.pending = false;
        },
        [frontsTypes.ADD_OPTIONAL_SCOPE_FAILURE]: function (state, error) {
            state.addOptionalScope.error = error;
            state.addOptionalScope.pending = false;
        },
        [frontsTypes.REMOVE_OPTIONAL_SCOPE_REQUEST]: function (state) {
            state.removeOptionalScope.pending = true;
        },
        [frontsTypes.REMOVE_OPTIONAL_SCOPE_SUCCESS]: function (state) {
            state.removeOptionalScope.error = null;
            state.removeOptionalScope.pending = false;
        },
        [frontsTypes.REMOVE_OPTIONAL_SCOPE_FAILURE]: function (state, error) {
            state.removeOptionalScope.error = error;
            state.removeOptionalScope.pending = false;
        },
    },
    actions: {
        async getDefaultScopes({ commit }, payload) {
            commit(frontsTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS)
            return new Promise((resolve, reject) => {
                fronts
                    .getDefaultScopes(
                        payload.uuid,
                    )
                    .then((roles) => {
                        commit(frontsTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(frontsTypes.FETCH_ALL_DEFAULT_SCOPES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addDefaultScope({ commit }, payload) {
            commit(frontsTypes.ADD_DEFAULT_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts.addDefaultScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(frontsTypes.ADD_DEFAULT_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(frontsTypes.ADD_DEFAULT_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async removeDefaultScope({ commit }, payload) {
            commit(frontsTypes.REMOVE_DEFAULT_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts.removeDefaultScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(frontsTypes.REMOVE_DEFAULT_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(frontsTypes.REMOVE_DEFAULT_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async getOptionalScopes({ commit }, payload) {
            commit(frontsTypes.FETCH_ALL_OPTIONAL_SCOPES_REQUEST)
            return new Promise((resolve, reject) => {
                fronts
                    .getOptionalScopes(
                        payload.uuid,
                    )
                    .then((roles) => {
                        commit(frontsTypes.FETCH_ALL_OPTIONAL_SCOPES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(frontsTypes.FETCH_ALL_OPTIONAL_SCOPES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addOptionalScope({ commit }, payload) {
            commit(frontsTypes.ADD_OPTIONAL_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts.addOptionalScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(frontsTypes.ADD_OPTIONAL_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(frontsTypes.ADD_OPTIONAL_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async removeOptionalScope({ commit }, payload) {
            commit(frontsTypes.REMOVE_OPTIONAL_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                fronts.removeOptionalScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(frontsTypes.REMOVE_OPTIONAL_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(frontsTypes.REMOVE_OPTIONAL_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
    }
}